// Auto generated file, do not manually modify!
// com.hotpads.adproducts.client.enums.ZuoraInvoiceType

export enum ZuoraInvoiceType {
  FLAT_FEE_FEED_CONNECT = 'flatFeeFeedConnect',
  MULTIFAMILY = 'multifamily',
  NUCLEUS_LISTING = 'nucleusListing',
  SINGLE_FAMILY_BOOST = 'singleFamilyBoost',
  SINGLE_FAMILY_DAILY_LISTINGS = 'singleFamilyDailyListings',
  SINGLE_FAMILY_FLAT_FEE = 'singleFamilyFlatFee',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_PAY_PER_LISTING = 'singleFamilyPayPerListing',
  SINGLE_FAMILY_REIT = 'singleFamilyReit',
  SINGLE_FAMILY_SPOTLIGHT = 'singleFamilySpotlight',
}

export const ZuoraInvoiceType_values = [
  ZuoraInvoiceType.FLAT_FEE_FEED_CONNECT,
  ZuoraInvoiceType.MULTIFAMILY,
  ZuoraInvoiceType.NUCLEUS_LISTING,
  ZuoraInvoiceType.SINGLE_FAMILY_BOOST,
  ZuoraInvoiceType.SINGLE_FAMILY_DAILY_LISTINGS,
  ZuoraInvoiceType.SINGLE_FAMILY_FLAT_FEE,
  ZuoraInvoiceType.SINGLE_FAMILY_PAY_PER_LISTING,
  ZuoraInvoiceType.SINGLE_FAMILY_REIT,
  ZuoraInvoiceType.SINGLE_FAMILY_SPOTLIGHT,
] as const;
